// extracted by mini-css-extract-plugin
export var card = "icon-card-module--card--SnNgB";
export var description = "icon-card-module--description--LPfQj";
export var headline = "icon-card-module--headline--HtLCH";
export var iconWrapper = "icon-card-module--icon-wrapper--v2cTD";